import { ChangeDetectorRef, Component, AfterViewInit, AfterViewChecked } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core';
import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
  ViewModes,
} from '@spartacus/storefront';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'cx-product-list',
  templateUrl: './product-ekitem-list.component.html',
  styleUrls: ['./product-ekitem-list.component.scss'],
})
export class ProductEkitemListComponent  extends ProductListComponent implements AfterViewChecked{
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;
  component: any;

  constructor(
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    scrollConfig: ViewConfig,
    private globalMessageService: GlobalMessageService,
    public translation: TranslationService,
    public cdf: ChangeDetectorRef
  ) {
    super(pageLayoutService, productListComponentService, scrollConfig);
  }
 
  ngAfterViewChecked(): void {
    let collection = document.getElementsByClassName("focus-lock");
    for(let i =0 ; i < collection.length;i++){
      let elem = collection[i].firstChild;
      if(elem?.textContent === " allCategories "){
          collection[i].setAttribute("style", "visibility: hidden");
      } 
    }
  }

  ngOnInit(): void {
    this.translation.translate('formErrors.globalMsg').subscribe((data) => {
      if (data) {
        this.globalMessageService.add(
          data ?? '',
          GlobalMessageType.MSG_TYPE_INFO,
          600000
        );
        this.cdf.detectChanges();
      }
    });
  }
  ngOnDestroy(): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
  }
}
